import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MachineTabIcon, MyDashBoardIcon } from "../../assets/Icons";

const Sidebar = ({ sideBar, setSideBar }) => {
  var location = useLocation();
  var navigate = useNavigate();
  const handleClick = (path, state) => {
    return navigate(path, state);
  };

  useEffect(() => {
    var path = location.pathname;
    var active = "dashboard";
    if (path.startsWith("/monitoring")) active = "monitoring";
    else if (path.startsWith("/dashboard")) active = "dashboard";
    setActiveTab(active);
  }, [location.pathname]);

  const [activeTab, setActiveTab] = useState("dashboard");
  return (
    <div>
      <div className="mainside">
        <div className={sideBar ? "sidmenu active" : "sidmenu"}>
          <div className="mainsidelist">
            <ul>
              <li className={`${activeTab == "dashboard" ? "active" : ""}`} onClick={() => handleClick(`/dashboard`)}>
                <MyDashBoardIcon />
                <p className="ms-3">Dashboard</p>
              </li>
              <li className={`${activeTab == "monitoring" ? "active" : ""}`} onClick={() => handleClick(`/monitoring`)}>
                <MachineTabIcon />
                <p className="ms-3">Monitoring</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
